import { createFileRoute } from "@tanstack/react-router"
import {
  PageRequest,
  ResourceObjectPageRequest,
} from "@/orval/gen/model/index.ts"
import { ResourceObjectsPage } from "../-components/ResourceObjectsPage"

export const Route = createFileRoute("/app/resources/resource-objects/")({
  component: ResourceObjectsPage,
  beforeLoad: ({ context: { t } }) => ({
    getTitle: () => t && t("Resources_Title"),
  }),
  validateSearch: (
    search: Omit<ResourceObjectPageRequest, keyof PageRequest>
  ) => ({
    ...search,
    available: search.available ?? true,
  }),
})
